import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const PURCHASES = [{
  name: 'María José R.',
  country: 'México'
}, {
  name: 'Lucía F.',
  country: 'Colombia'
}, {
  name: 'Andrea M.',
  country: 'Argentina'
}, {
  name: 'Paola G.',
  country: 'Perú'
}, {
  name: 'Daniela S.',
  country: 'España'
}, {
  name: 'Carmen T.',
  country: 'Chile'
}, {
  name: 'Sofía L.',
  country: 'Ecuador'
}];
export function PurchasePopup() {
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showPopup = () => {
      const randomPurchase = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
      setCurrentPurchase(randomPurchase);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Show for 5 seconds
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 3000);
    // Then interval
    const interval = setInterval(() => {
      showPopup();
    }, 15000); // Every 15 seconds
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-38">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 bg-white rounded-lg shadow-xl p-4 flex items-start gap-3 max-w-[300px] border border-[#f0e6d2]" data-id="element-39">
          <div className="bg-[#fdf8f5] p-2 rounded-full text-[#c08a92] shrink-0" data-id="element-40">
            <CheckCircle2 size={20} data-id="element-41" />
          </div>
          <div className="flex-1" data-id="element-42">
            <p className="text-sm text-gray-800 font-medium leading-tight" data-id="element-43">
              <span className="font-bold" data-id="element-44">{currentPurchase.name}</span> de{' '}
              {currentPurchase.country} acaba de comprar el Kit de Reseteo
              Emocional™
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-45">hace unos minutos</p>
          </div>
          <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600 shrink-0" data-id="element-46">
            ×
          </button>
        </motion.div>}
    </AnimatePresence>;
}